import { render, staticRenderFns } from "./YagiprimeFontPaymentDialog.vue?vue&type=template&id=646607ba&scoped=true"
import script from "./YagiprimeFontPaymentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiprimeFontPaymentDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./YagiprimeFontPaymentDialog.vue?vue&type=style&index=1&id=646607ba&prod&lang=scss&scoped=true"
import style2 from "./YagiprimeFontPaymentDialog.vue?vue&type=style&index=2&id=646607ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646607ba",
  null
  
)

export default component.exports